export const getCurrentValue = state => state.bottomNavigation.currentValue;

export const getDesktopNotificationsOpen = state =>
  state.bottomNavigation.desktopNotificationsOpen;
